import { createRouter, createWebHistory } from "vue-router";
import ContactView from "@/views/ContactView.vue";
import ServicesView from "@/views/ServicesView.vue";
import AboutView from "@/views/AboutView.vue";
import HomeView from "@/views/HomeView.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: HomeView,
  },
  {
    path: "/about",
    name: "About",
    component: AboutView,
    meta: { title: "About - Tech Direct Solutions" },
  },
  {
    path: "/services",
    name: "Services",
    component: ServicesView,
    meta: { title: "Services - Tech Direct Solutions" },
  },
  {
    path: "/contact",
    name: "Contact",
    component: ContactView,
    meta: { title: "Contact Us - Tech Direct Solutions" },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  // This will be called before any route change
  document.title = to.meta.title || "Tech Direct Solutions";
  window.scrollTo(0, 0);
  next();
});

export default router;
